// Keeps the qualification dropdowns looking like the other registration
// inputs, and shows/hides library conditional follow-ups based on parent
// option ids. Required questions are enforced natively via the select's
// `required` attribute (conditional children get required only when visible).
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select", "field"];

  connect() {
    this.selectTargets.forEach((select) => this.updateColor(select));
    this.refreshConditionals();
  }

  change(event) {
    this.updateColor(event.currentTarget);
    this.refreshConditionals();
  }

  updateColor(select) {
    if (select.value === "") {
      select.classList.add("qual-placeholder");
    } else {
      select.classList.remove("qual-placeholder");
    }
  }

  refreshConditionals() {
    const answers = {};
    this.selectTargets.forEach((select) => {
      const qid = select.dataset.questionId;
      if (qid) answers[qid] = select.value;
    });

    this.fieldTargets.forEach((field) => {
      const parentId = field.dataset.parentQuestionId;
      if (!parentId) return;

      const showWhen = (field.dataset.showWhenOptionIds || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const parentAnswer = answers[parentId];
      const visible = parentAnswer && showWhen.includes(parentAnswer);
      const select = field.querySelector("select");

      field.hidden = !visible;
      if (select) {
        select.required = Boolean(visible && select.dataset.wasRequired !== "false");
        if (!visible) {
          select.value = "";
          this.updateColor(select);
        }
      }
    });
  }
}
